#import "./AssetFields.graphql"

mutation ReturnAsset(
  $assetId: ID!
  $returnedOn: ISO8601Date
  $returnMethod: AssetReturnMethodEnum!
  $status: AssetStatusEnum
  $returnCondition: AssetConditionEnum
  $location: AssetLocationEnum
  $notes: String
) {
  returnAsset(
    input: {
      assetId: $assetId
      returnedOn: $returnedOn
      returnMethod: $returnMethod
      status: $status
      returnCondition: $returnCondition
      location: $location
      notes: $notes
    }
  ) {
    asset {
      ...AssetFields
    }
  }
}
